import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const Footer = () => {
  useEffect(() => {
    // Add Font Awesome if not already added
    const faLink = document.querySelector('link[href*="font-awesome"]');
    if (!faLink) {
      const link = document.createElement("link");
      link.href = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css";
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
  }, []);

  return (
    <footer id="contact" className="text-white text-sm border-t border-gray-800 scroll-snap-align-start min-h-screen flex flex-col justify-center" style={{ backgroundColor: 'rgb(17 24 39 / var(--tw-bg-opacity, 1))' }}>
      <div className="container mx-auto px-8 md:px-12 py-12 flex-grow flex flex-col justify-center">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <h4 className="text-white text-lg font-bold mb-4">Advantis – International Express</h4>
            <p className="mb-4 max-w-md" style={{ color: 'rgb(156 163 175 / var(--tw-text-opacity, 1))'}} >
            Sri Lanka’s Authorised Global Service Provider for FedEx, committed to reliable
international express delivery and reducing environmental impact through
responsible, sustainable operations.
            </p>
            <div className="flex gap-4 mt-6" style={{ color: 'rgb(156 163 175 / var(--tw-text-opacity, 1))'}} >
              <a 
                href="https://www.facebook.com/share/eXQepF8jgsbwjHnA/?mibextid=qi2Omg" 
                target="_blank" 
                rel="noopener noreferrer" 
                className=" hover:text-brand-accent transition"
              >
                <i className="fab fa-facebook fa-lg"></i>
              </a>
              <a 
                href="https://www.linkedin.com/company/81911039/admin/feed/posts/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-brand-accent transition"
              >
                <i className="fab fa-linkedin fa-lg"></i>
              </a>
              <a 
                href="https://www.instagram.com/advantisexpress/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-brand-accent transition"
              >
                <i className="fab fa-instagram fa-lg"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h5 className="text-white font-bold mb-4">Quick Links</h5>
            <ul className="space-y-2" style={{ color: 'rgb(156 163 175 / var(--tw-text-opacity, 1))'}} >
              <li><Link to="/track" className="hover:text-brand-blue transition">Track Package</Link></li>
              <li><Link to="/shipping-rates" className="hover:text-brand-blue transition">Get Rates</Link></li>
              <li><Link to="/customer-support" className="hover:text-brand-blue transition">Customer Support</Link></li>
              <li><a href="https://www.fedex.com/en-us/sustainability.html" target="_blank" rel="noopener noreferrer" className="hover:text-brand-blue transition">Sustainability</a></li>
            </ul>
          </div>

          <div>
            <h5 className="text-white font-bold mb-4">Contact Us</h5>
            <ul className="space-y-2" style={{ color: 'rgb(156 163 175 / var(--tw-text-opacity, 1))'}}  >
              <li className="flex items-start gap-2">
                <i className="fas fa-map-marker-alt mt-1"></i>
                <span>46/56, Lanlib Building,<br/>Nawam Mawatha, Colombo 2</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fas fa-phone"></i>
                <a href="tel:+94115422222">+94 11 542 2222</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="fas fa-envelope"></i>
                <a href="mailto:cs@fedexlk.com">cs@fedexlk.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Disclaimer Section */}
      <div className="py-6 mt-auto w-full" style={{ backgroundColor: 'rgb(0 0 0  / var(--tw-bg-opacity, 1))' }}>
        <div className="container mx-auto px-8 md:px-12 text-center md:text-left flex flex-col md:flex-row justify-between items-center gap-4">
          <p style={{ color: 'rgb(156 163 175 / var(--tw-text-opacity, 1))', fontSize: '0.795rem' }}>&copy; 2025 Advantis Express Pvt Ltd. All Rights Reserved.</p>
          <p className="max-w-xl text-center md:text-right" style={{ color: 'rgb(156 163 175 / var(--tw-text-opacity, 1))', fontSize:  '0.755rem' }}>
            FedEx is a registered trademark of Federal Express Corporation, used under license. This website is owned and operated by Advantis Express Pvt Ltd, an authorised Global Service Provider for FedEx.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;